module.exports = __webpack_public_path__ + "img/main.66665cce.png";